import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollReset() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // 临时禁用平滑滚动，确保立即滚动到顶部
    const originalScrollBehavior =
      document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "auto";

    // 立即滚动到顶部
    window.scrollTo(0, 0);

    // 恢复原始滚动行为设置
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = originalScrollBehavior;
    }, 0);
  }, [pathname]);

  return null;
}

export default ScrollReset;
